import { COMPANY_LOGO } from "../../Components/Report/constants";
import { Result, Spin } from "antd";
import "./TeamSelection.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectManagerTeam } from "@store/actions/manager.actions";
import { useEffect, useMemo } from "react";

const ATHLETE_HINT =
  "If you are an athlete, you may have access to the Whistle Performance mobile app if your coach has signed you up.";

export const TeamSelection = () => {
  const dispatch = useDispatch();
  const { teams: teamsData, selectedTeam, teamsStatus } = useSelector(({ manager }) => manager);
  const navigate = useNavigate();

  const teams = useMemo(() => {
    if (!teamsData) return [];

    return [...teamsData].sort((a, b) => {
      return a.display_name.localeCompare(b.display_name);
    });
  }, [teamsData]);

  const location = useLocation();
  const searchQuery = location.search || "";

  const handleSelectTeam = async (team) => {
    const valid = await dispatch(selectManagerTeam(team.id, navigate));
    if (valid) {
      navigate("/overview" + searchQuery);
      //window.location.reload(true);
    }
  };

  const renderEmptyState = () => {
    const statusCode = (
      <div style={{ marginTop: 8, color: "#8c8c8c", fontSize: 13 }}>
        {`Status code: ${teamsStatus || "N/A"}`}
      </div>
    );

    // 2xx with an empty list — authenticated, but no teams are linked to the account.
    if (teamsStatus >= 200 && teamsStatus < 300) {
      return (
        <Result
          status="info"
          title="Your account is not linked to any teams on the Whistle Performance Web Platform."
          subTitle={ATHLETE_HINT}
          extra={statusCode}
        />
      );
    }

    // 4xx — the backend denied access to the teams resource.
    if (teamsStatus >= 400 && teamsStatus < 500) {
      return (
        <Result
          status="warning"
          title="You do not have access to any teams on the Whistle Performance Web Platform."
          subTitle={ATHLETE_HINT}
          extra={statusCode}
        />
      );
    }

    // 5xx or no HTTP response (network/CORS/timeout) — a transient failure; the user can refresh to retry.
    return (
      <Result
        status="error"
        title="Something went wrong loading your teams."
        extra={statusCode}
      />
    );
  };

  useEffect(() => {
    if (teams.length === 1) {
      if (selectedTeam) {
        navigate("/overview" + searchQuery);
      } else {
        handleSelectTeam(teams[0]);
      }
    }
  }, [teams]);

  return (
    <div style={{ display: "flex", justifyContent: "center", height: "100vh" }}>
      <div
        style={{
          width: 900,
          marginTop: "6%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={COMPANY_LOGO} style={{ width: "auto", height: 60, objectFit: "contain" }} />

        {teamsStatus === null ? (
        <Spin size="large" style={{ marginTop: "10%" }} />
        ) : teams.length == 0 ? (
        renderEmptyState()
        ) : (<>
        <h4 style={{ margin: "24px 0px" }}>Select Your Team</h4>

        <h6>Select your team to manage your training</h6>

        <div style={{ marginTop: 24, width: "100%", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
          {teams.map((team) => (
            <div
              className="team-item"
              onClick={() => handleSelectTeam(team)}
              key={team.id}
            >
              <img src={team.team_logo} style={{ width: 48, height: 48, flexShrink: 0, borderRadius: 4, objectFit: "contain" }} />
              <span style={{ flex: 1, fontSize: 15, marginLeft: 10, fontWeight: 600 }}>{team.display_name}</span>
            </div>
          ))}
        </div>
        </>
        )
      }
      </div>
    </div>
  );
};
